import Immutable from 'seamless-immutable'
import { createReducer } from 'reduxsauce'

import { Types } from './actions'

export const INITIAL_STATE = Immutable({
  activeControl: 'Form',
  lastActiveControl: null,
  complexState: false,
})

const setActiveControl = (state, action) =>
  state.merge({
    activeControl: action.activeControl,
    lastActiveControl: state.activeControl,
  })

const setComplexStage = (state, action) =>
  state.merge({
    complexState: action.complex,
  })

const ACTION_HANDLERS = {
  [Types.SET_ACTIVE_CONTROL]: setActiveControl,
  [Types.SET_COMPLEX_STAGE]: setComplexStage,
}

export default createReducer(INITIAL_STATE, ACTION_HANDLERS)
